var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 1.45455C1.90827 1.45455 1.42857 1.94296 1.42857 2.54545V13.4545C1.42857 14.057 1.90827 14.5455 2.5 14.5455H17.5C18.0917 14.5455 18.5714 14.057 18.5714 13.4545V2.54545C18.5714 1.94296 18.0917 1.45455 17.5 1.45455H2.5ZM0 2.54545C0 1.13964 1.11929 0 2.5 0H17.5C18.8807 0 20 1.13964 20 2.54545V13.4545C20 14.8604 18.8807 16 17.5 16H2.5C1.11929 16 0 14.8604 0 13.4545V2.54545Z",
    fill: "#98A2B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00761 3.18986C3.2498 2.87281 3.69857 2.81569 4.00996 3.06229L10 7.80592L15.99 3.06229C16.3014 2.81569 16.7502 2.87281 16.9924 3.18986C17.2346 3.50691 17.1785 3.96384 16.8671 4.21044L10.4385 9.30135C10.1806 9.50561 9.81941 9.50561 9.56147 9.30135L3.1329 4.21044C2.82151 3.96384 2.76541 3.50691 3.00761 3.18986Z",
    fill: "#98A2B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelop);
export default __webpack_public_path__ + "static/media/envelop.10e939040ff210a989a77abae9d6860a.svg";
export { ForwardRef as ReactComponent };